import { BrowserRouter } from 'react-router-dom'; 
import Main from './routes/MainComponent'
import './App.css';
import { Provider } from 'react-redux';
import { ConfigureStore } from './redux/configureStore';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const store = ConfigureStore();
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if(pathname != '/examination-as-a-servie') {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter> 
      <ScrollToTop />
        <div className="App scroll-container">
          <Main/>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
